import { createReducer } from 'redux-create-reducer'
import {
  FORM_REFERRAL_INVITE_RESET,
  FORM_REFERRAL_INVITE_UPDATE,
} from '@disco/constants/ActionTypes'
const initialState = {
  message: '',
  recipients: [] as Array<any>,
}
export type State = typeof initialState
export const referralInviteReducer = createReducer<State, any>(initialState, {
  [FORM_REFERRAL_INVITE_RESET]() {
    return initialState
  },

  [FORM_REFERRAL_INVITE_UPDATE](state, action) {
    return { ...state, ...action.fields }
  },
})
